import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";

import * as Admin from "../../../store/ducks/admin.duck";
import { Grid, Paper } from "@material-ui/core";

import { Formik } from "formik";
import * as Yup from "yup";

import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function MedipassCodes() {
  const [searchTerm, setSearchTerm] = useState("");
  const medipassCodes = useSelector((state) => state.admin.MedipassCodes);
  // const psychologistMedipassCodes = medipassCodes.filter(medipasscode => medipasscode.istemplate === 0)
  const filteredMedipassCodes = medipassCodes.filter((medipasscode) => medipasscode.code.search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0);
  const role = useSelector((state) => state.auth.roleDesc);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Admin.actions.fetchMedipassCodes());
  }, [dispatch]);

  var [show, setShow] = useState(false);
  var [showConfirmation, setShowConfirmation] = useState(false);
  var [currentCodeID, setCurrentCodeID] = useState();
  var [currentCode, setCurrentCode] = useState();
  var [currentDescription, setCurrentDescription] = useState();
  var [currentCost, setCurrentCost] = useState();
  var [deleteCode, setDeleteCode] = useState();
  var [deleteCodeDescription, setDeleteCodeDescription] = useState();
  var [deleteCodeCost, setDeleteCodeCost] = useState();

  const loadCodeDetail = (thisCode) => {
    setCurrentCodeID(thisCode.id);
    setCurrentCode(thisCode.code);
    setCurrentDescription(thisCode.description);
    setCurrentCost(thisCode.cost);
    setShow(true);
  };

  const createNewCode = (thisCode) => {
    setCurrentCodeID(0);
    setCurrentCode();
    setCurrentDescription();
    setCurrentCost("0");
    setShow(true);
  };

  function deleteMedipassCode() {
    // Soft delete medipass code
    dispatch(Admin.actions.deleteMedipassCode({ code: deleteCode }));
    setShowConfirmation(false);
  }

  function deleteConfirmation(delCode) {
    setDeleteCode(delCode);
    setDeleteCodeDescription(medipassCodes.find((item) => item.code === delCode).description);
    setDeleteCodeCost(medipassCodes.find((item) => item.code === delCode).cost);
    setShowConfirmation(true);
  }

  function handleConfirmationClose() {
    setShowConfirmation(false);
  }

  const MedipassCodeSchema = Yup.object().shape({
    code: Yup.string().required("Code is required"),
    description: Yup.string().min(5, "Description must be more than 5 characters").required("Description is required"),
    cost: Yup.number().typeError("Cost must be a number").required("Cost is required"),
  });

  const columns = [
    { field: "id", headerName: "ID", width: 100, hide: true },
    {
      field: "code",
      headerName: "Code",
      width: 100,
      renderCell: (params) => (
        <strong>
          {params.row.istemplate === 0 || role === "Admin" ? (
            <div onClick={() => loadCodeDetail(medipassCodes.find((medipasscode) => medipasscode.code === params.row.code))} className="cell-Link">
              {params.value}
            </div>
          ) : (
            <div>{params.value}</div>
          )}
        </strong>
      ),
    },
    { field: "description", headerName: "Description", width: 500 },
    { field: "cost", headerName: "Cost", width: 120 },
    { field: "istemplate", headerName: "Template", width: 150, renderCell: (params) => <>{params.row.istemplate === 0 ? "N" : "Y"}</> },
    {
      field: "none",
      headerName: "Actions",
      width: 270,
      renderCell: (params) => (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => deleteConfirmation(params.row.code)}
            style={{ color: "black", fontWeight: 500, border: 0, background: "#eee" }}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  function handleClose() {
    setShow(false);
  }

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <h4 style={{ marginBottom: 12 }}>Medicare Code Maintenance</h4>
        </Grid>
      </Grid>

      <Paper>
        <Grid container justifyContent="space-between" style={{ padding: 10 }}>
          <Grid item style={{ marginTop: 2, marginLeft: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="text" value={searchTerm} onChange={(event) => handleSearch(event)} autoComplete="OFF" />
            </InputGroup>
          </Grid>
          <Grid item style={{ marginLeft: 20, marginRight: 10 }}>
            <Button variant="primary" size="sm" onClick={() => createNewCode()}>
              Create Code
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {medipassCodes ? (
        <Paper style={{ height: 700 }}>
          <DataGrid rows={filteredMedipassCodes} columns={columns} pageSize={20} checkboxSelection={false} rowHeight={40} />
        </Paper>
      ) : (
        "None"
      )}

      <Modal show={showConfirmation} onHide={handleConfirmationClose} dialogClassName="edit-md-sm-dialog-modal">
        <Modal.Header className="edit-md-sm-modal">
          <Modal.Title>Delete Score Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          <Row>
            <Col md="3">
              <Form.Group>
                <Form.Label>Medicare Code</Form.Label>
                <Form.Control type="text" name="code" defaultValue={deleteCode} readOnly />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control as="textarea" rows={6} name="description" defaultValue={deleteCodeDescription} readOnly />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md="3">
              <Form.Group>
                <Form.Label>Cost</Form.Label>
                <Form.Control type="text" name="cost" defaultValue={deleteCodeCost} readOnly />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="edit-md-modal">
          <Button variant="secondary" onClick={handleConfirmationClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={() => deleteMedipassCode()}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose} dialogClassName="contracts-modal">
        <Modal.Header closeButton className="contracts-modal">
          <Modal.Title>Code Maintenance</Modal.Title>
        </Modal.Header>

        <Formik
          enableReinitialize
          initialValues={{
            code: currentCode || "",
            description: currentDescription || "",
            cost: currentCost || "",
          }}
          validationSchema={MedipassCodeSchema}
          onSubmit={(values) => {
            const payload = {
              id: currentCodeID,
              code: values.code,
              description: values.description,
              cost: values.cost,
            };

            dispatch(Admin.actions.putMedipassCode(payload));
            setShow(false);
          }}
        >
          {({ handleSubmit, handleChange, values, errors, touched, isValid, dirty }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body className="contracts-modal">
                <Row>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Medicare Code</Form.Label>
                      <Form.Control type="text" name="code" value={values.code} onChange={handleChange} isInvalid={touched.code && !!errors.code} />
                      <Form.Control.Feedback type="invalid">{errors.code}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <Form.Group>
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={6}
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        isInvalid={touched.description && !!errors.description}
                      />
                      <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Cost</Form.Label>
                      <Form.Control type="text" name="cost" value={values.cost} onChange={handleChange} isInvalid={touched.cost && !!errors.cost} />
                      <Form.Control.Feedback type="invalid">{errors.cost}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Modal.Body>

              <Modal.Footer className="contracts-modal">
                <Button variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit" disabled={!isValid || !dirty}>
                  Save
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
